import { render, staticRenderFns } from "./QuotationList.vue?vue&type=template&id=1d4654a7&scoped=true&"
import script from "./QuotationList.vue?vue&type=script&lang=js&"
export * from "./QuotationList.vue?vue&type=script&lang=js&"
import style0 from "./QuotationList.vue?vue&type=style&index=0&id=1d4654a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4654a7",
  null
  
)

export default component.exports